document.addEventListener('cart:item-added', function (evt) {
  addUpsellsToCart();
});

const currencyCode = document.getElementById('currencyCode').value;
const currencySymbol = document.getElementById('currencySymbol').value;
const rtlLocales = ['EUR', 'DKK'];

document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('prop65Modal')) {
    document.getElementById('prop65Modal').onclick = openProp65Modal;
  }

  // Initialize upsells show/hide - hide items beyond the 2nd (showing first 2 items)
  const upsellsLists = document.querySelectorAll('.upsells-list');
  upsellsLists.forEach(list => {
    const items = list.querySelectorAll(
      '.upsell-container:not(.priming-pump-upsell)'
    );
    items.forEach((item, index) => {
      if (index >= 2) {
        item.classList.add('upsell-item-hidden');
      }
    });
  });
});

function openProp65Modal() {
  document.getElementById('prop65ModalWindow').style.display = 'block';
  disableScroll();
}

function closeProp65Modal() {
  document.getElementById('prop65ModalWindow').style.display = 'none';
  enableScroll();
}

function formatPrice(price) {
  var rightToLeft = false;
  rtlLocales.forEach(code => {
    if (code == currencyCode) {
      rightToLeft = true;
    }
  });
  if (rightToLeft) {
    return price + ' ' + currencySymbol;
  } else {
    return currencySymbol + price;
  }
}

function formatPriceWithCode(price) {
  var rightToLeft = false;
  rtlLocales.forEach(code => {
    if (code == currencyCode) {
      rightToLeft = true;
    }
  });
  let priceToReturn = '';
  if (rightToLeft) {
    priceToReturn = price + ' ' + currencySymbol;
  } else {
    priceToReturn = currencySymbol + price;
  }
  priceToReturn += ' ' + currencyCode;
  return priceToReturn;
}

function updateActiveColor(elemId) {
  const selectors = document.querySelectorAll('.option-color-selector');
  for (let i = 0; i < selectors.length; i++) {
    selectors[i].classList.remove('active');
  }
  document.getElementById(elemId).classList.add('active');
}

function addUpsellsToCart() {
  const allUpsells = document.querySelectorAll('.upsell-container');
  let upsellsToAdd = [];
  for (let i = 0; i < allUpsells.length; i++) {
    const u = allUpsells[i];
    if (u.classList.contains('active')) {
      const atcIdElement = u.querySelector('.upsell-atc-id');
      if (atcIdElement) {
        upsellsToAdd.push(atcIdElement.value);
      }
    }
  }
  if (upsellsToAdd.length > 0) {
    let formData = {
      items: [],
    };

    upsellsToAdd.forEach(u => formData.items.push({ id: u, quantity: 1 }));
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(response => {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}

//Format gallon calculation
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function closeUpsellModal() {
  document.getElementById('upsellModal').style.display = 'none';
  enableScroll();
}

function openUpsellModal(id) {
  const upsellImageURL = document.getElementById(id + '-upsell-image').value;
  const upsellDescription = document.getElementById(
    id + '-upsell-description'
  ).innerHTML;

  document.getElementById('upsell-modal-image').src = upsellImageURL;
  document.getElementById('upsell-modal-info').innerHTML = upsellDescription;

  document.getElementById('upsellModal').style.display = 'block';
  disableScroll();
}

function elementIsActive(elem) {
  let isActive = false;
  for (let i = 0; i < elem.classList.length; i++) {
    if (elem.classList[i] == 'active') {
      isActive = true;
    }
  }
  return isActive;
}

let priceRenderInterval = null;

function renderPrices() {
  const mainPrice = document
    .querySelector('.product-price-container')
    .querySelector('.main-price');
  let mainComparePrice = document
    .querySelector('.product-price-container')
    .querySelector('.compare-price');

  const atcPrice = document.getElementById('atc_button_price');
  const atcComparePrice = document.getElementById('atc_button_compare_price');

  const selectedVariantCost = document.getElementById(
    'selectedVariantCost'
  ).value;
  const selectedVariantComparePrice = document.getElementById(
    'selectedVariantComparePrice'
  ).value;
  const totalUpsellCost = document.getElementById('totalUpsellCost').value;

  const mainPriceToRender = getRenderedPrice(
    parseInt(selectedVariantCost) + parseInt(totalUpsellCost)
  );
  const comparePriceToRender = getRenderedPrice(
    parseInt(selectedVariantComparePrice) + parseInt(totalUpsellCost)
  );

  clearInterval(priceRenderInterval);
  mainPrice.innerHTML = formatPriceWithCode(mainPriceToRender);
  priceRenderInterval = setInterval(function () {
    updateMainPrice(mainPriceToRender);
  }, 250);

  atcPrice.innerHTML = formatPriceWithCode(mainPriceToRender);

  if (selectedVariantComparePrice) {
    updateMainComparePrice(comparePriceToRender);
    atcComparePrice.innerHTML = formatPriceWithCode(comparePriceToRender);
  }
}

function updateMainComparePrice(comparePriceToRender) {
  window.setTimeout(function () {
    let mainComparePrice = document
      .querySelector('.product-price-container')
      .querySelector('.compare-price');
    if (
      mainComparePrice == null ||
      mainComparePrice == undefined ||
      mainComparePrice == 'null' ||
      !mainComparePrice
    ) {
      updateMainComparePrice(comparePriceToRender);
    } else {
      mainComparePrice.innerHTML = formatPriceWithCode(comparePriceToRender);
    }
  }, 50);
}

function updateMainPrice(mainPriceToRender) {
  document
    .querySelector('.product-price-container')
    .querySelector('.main-price').innerHTML =
    formatPriceWithCode(mainPriceToRender);
}

function toggleUpsellsShowMore(button) {
  // Button parameter is always provided now
  if (!button) return;

  let upsellsList;
  let showMoreBtn = button;

  // Check if it's a variant-specific upsells section
  const variantSection = button.closest('.variant-upsells-section');
  if (variantSection) {
    // Variant-specific upsells
    upsellsList = variantSection.querySelector('.upsells-list');
  } else {
    // Main upsells section - find the section that's a sibling of the button's container
    const wrapper = button.closest('.upsells-section-wrapper');
    if (!wrapper) return;
    const section = wrapper.querySelector(
      '.upsells-section:not(.variant-upsells-section)'
    );
    if (!section) return;
    upsellsList = section.querySelector('.upsells-list');
  }

  if (!upsellsList || !showMoreBtn) return;

  const hiddenItems = upsellsList.querySelectorAll('.upsell-item-hidden');
  const showMoreText = showMoreBtn.querySelector('.show-more-text');
  const showLessText = showMoreBtn.querySelector('.show-less-text');
  const showMoreIcon = showMoreBtn.querySelector('.show-more-icon');
  const showLessIcon = showMoreBtn.querySelector('.show-less-icon');

  if (hiddenItems.length > 0) {
    // Show more items
    hiddenItems.forEach(item => {
      item.classList.remove('upsell-item-hidden');
    });
    if (showMoreText) showMoreText.style.display = 'none';
    if (showLessText) showLessText.style.display = 'inline';
    if (showMoreIcon) showMoreIcon.style.display = 'none';
    if (showLessIcon) showLessIcon.style.display = 'inline';
  } else {
    // Show less items (hide items after the 2nd, showing first 2 items)
    const allItems = upsellsList.querySelectorAll(
      '.upsell-container:not(.priming-pump-upsell)'
    );
    allItems.forEach((item, index) => {
      if (index >= 2) {
        item.classList.add('upsell-item-hidden');
      }
    });
    if (showMoreText) showMoreText.style.display = 'inline';
    if (showLessText) showLessText.style.display = 'none';
    if (showMoreIcon) showMoreIcon.style.display = 'inline';
    if (showLessIcon) showLessIcon.style.display = 'none';
  }
}

function toggleUpsell(id) {
  const upsellContainer = document.getElementById(id + '-upsell-container');

  // Find checkbox by looking for the label that's associated with this container
  const checkboxId = 'upsell-checkbox-' + id;
  const upsellCheckbox = document.getElementById(checkboxId);

  if (!upsellContainer) return;

  // Try to find cost input - first with full ID, then within container (for variant-specific upsells)
  let upsellCostInput = document.getElementById(id + '-upsell-cost');
  if (!upsellCostInput && upsellContainer) {
    // For variant-specific upsells, the cost input ID is just the upsell ID without variant ID
    // Try to find it within the container
    upsellCostInput = upsellContainer.querySelector(
      'input[id$="-upsell-cost"]'
    );
  }

  if (!upsellCostInput) return;

  const upsellCost = parseInt(upsellCostInput.value) || 0;
  const totalUpsellCost = document.getElementById('totalUpsellCost');

  if (!totalUpsellCost) {
    // Create totalUpsellCost if it doesn't exist
    const input = document.createElement('input');
    input.id = 'totalUpsellCost';
    input.type = 'hidden';
    input.value = '0';
    document.body.appendChild(input);
  }

  // Check the checkbox state first (this reflects the user's click)
  // Use checkbox state as source of truth to avoid double-toggling
  const shouldBeActive = upsellCheckbox
    ? upsellCheckbox.checked
    : !upsellContainer.classList.contains('active');
  const isActive = upsellContainer.classList.contains('active');

  // Only toggle if the state doesn't match
  if (shouldBeActive && !isActive) {
    // Selecting
    upsellContainer.classList.add('active');
    if (upsellCheckbox) {
      upsellCheckbox.checked = true;
    }
    const currentTotal = parseInt(totalUpsellCost.value) || 0;
    totalUpsellCost.value = currentTotal + upsellCost;
  } else if (!shouldBeActive && isActive) {
    // Deselecting
    upsellContainer.classList.remove('active');
    if (upsellCheckbox) {
      upsellCheckbox.checked = false;
    }
    const currentTotal = parseInt(totalUpsellCost.value) || 0;
    totalUpsellCost.value = Math.max(0, currentTotal - upsellCost);
  }

  renderPrices();
}

function disableScroll() {
  document.body.style.overflowY = 'hidden';
}

function enableScroll() {
  document.body.style.overflowY = 'scroll';
}

function openSizeModal() {
  document.getElementById('sizeModal').style.display = 'block';
  disableScroll();
}

function closeSizeModal() {
  document.getElementById('sizeModal').style.display = 'none';
  enableScroll();
}

window.onclick = function (event) {
  if (event.target == document.getElementById('upsellModal')) {
    document.getElementById('upsellModal').style.display = 'none';
    enableScroll();
  }

  if (event.target == document.getElementById('sizeModal')) {
    document.getElementById('sizeModal').style.display = 'none';
    enableScroll();
  }
};

var numbersToFormat = document.getElementsByClassName('number-to-format');
for (let i = 0; i < numbersToFormat.length; i++) {
  numbersToFormat[i].innerHTML = numberWithCommas(numbersToFormat[i].innerHTML);
}

//Update Variant Details
document.addEventListener('product:variant-change', function (evt) {
  if (document.getElementById('filtrationSystem')?.value == 'false') return;
  const variant = evt.detail.variant;

  //Enable/Disable ATC button based on availability
  if (variant.available) {
    document.getElementById('AddToCart').disabled = false;
    document.getElementById('atc_button_text').innerHTML = 'ADD TO CART';
    // Hide all Klaviyo forms when variant is available
    const klaviyoForms = document.querySelectorAll('.js-klaviyo-stock-form');
    klaviyoForms.forEach(form => {
      form.classList.add('klaviyo__stock-form--hidden');
      form.setAttribute('aria-hidden', 'true');
    });
  } else {
    document.getElementById('AddToCart').disabled = true;
    document.getElementById('atc_button_text').innerHTML = 'SOLD OUT';

    // Hide all Klaviyo forms first
    const klaviyoForms = document.querySelectorAll('.js-klaviyo-stock-form');
    klaviyoForms.forEach(form => {
      form.classList.add('klaviyo__stock-form--hidden');
      form.setAttribute('aria-hidden', 'true');
    });

    // Show the appropriate Klaviyo form for this variant
    // First try variant-specific form
    const variantKlaviyoForm = document.querySelector(
      `.js-klaviyo-stock-form[data-variant-id="${variant.id}"]`
    );
    if (variantKlaviyoForm) {
      variantKlaviyoForm.classList.remove('klaviyo__stock-form--hidden');
      variantKlaviyoForm.setAttribute('aria-hidden', 'false');
    } else {
      // Fallback to product-level form (for products with only default variant)
      const productKlaviyoForm = document.querySelector(
        '.js-klaviyo-stock-form:not([data-variant-id])'
      );
      if (productKlaviyoForm) {
        productKlaviyoForm.classList.remove('klaviyo__stock-form--hidden');
        productKlaviyoForm.setAttribute('aria-hidden', 'false');
      }
    }
  }

  //Update Price
  if (document.getElementById('selectedVariantCost')) {
    document.getElementById('selectedVariantCost').value = variant.price;
  }
  if (document.getElementById('selectedVariantComparePrice')) {
    document.getElementById('selectedVariantComparePrice').value =
      variant.compare_at_price;
  }
  renderPrices();

  //Change Price/Compare Price In Active Variant
  document
    .querySelector('[data-variant-filter-count="' + variant.option2 + '"]')
    .querySelector('.filter-option-text--price').innerHTML = formatPrice(
    getRenderedPrice(variant.price)
  );
  if (variant.compare_at_price != null) {
    comparePriceToRender = formatPrice(
      getRenderedPrice(variant.compare_at_price)
    );
  } else {
    comparePriceToRender = '';
  }
  document
    .querySelector('[data-variant-filter-count="' + variant.option2 + '"]')
    .querySelector('.filter-option-text--compare-price').innerHTML =
    comparePriceToRender;

  //Change Price/Compare Price In Inactive Variants
  const variantContainers = document.getElementsByClassName(
    'filter-option-container'
  );
  for (let i = 0; i < variantContainers.length; i++) {
    if (variantContainers[i].dataset.variantFilterCount != variant.option2) {
      variantContainers[i].querySelector(
        '.filter-option-text--price'
      ).innerHTML = formatPrice(
        getRenderedPrice(
          document.getElementById(
            variant.option1 +
              ' / ' +
              variantContainers[i].dataset.variantFilterCount
          ).value
        )
      );
      let comparePriceToRender = document.getElementById(
        variant.option1 +
          ' / ' +
          variantContainers[i].dataset.variantFilterCount +
          '--compare'
      ).value;
      if (comparePriceToRender) {
        comparePriceToRender = formatPrice(
          getRenderedPrice(comparePriceToRender)
        );
      } else {
        comparePriceToRender = '';
      }
      document
        .querySelector(
          '[data-variant-filter-count="' +
            variantContainers[i].dataset.variantFilterCount +
            '"]'
        )
        .querySelector('.filter-option-text--compare-price').innerHTML =
        comparePriceToRender;
    }
  }

  // *START UPDATE BUTTON ACTIVE STATE* //

  //First make everything inactive
  const containers = document.getElementsByClassName('filter-option-container');
  for (let i = 0; i < containers.length; i++) {
    containers[i].classList.remove('active');
    containers[i].firstElementChild.classList.remove('active');
    //Also update relevant dataset
    containers[i].dataset.variantColor = variant.option1;
    containers[i].dataset.variantFilterCount = (i + 1) * 2 + ' Filters';
  }
  const promotions = document.getElementsByClassName('filter-promotion');
  for (let i = 0; i < promotions.length; i++) {
    promotions[i].classList.remove('active');
    promotions[i]
      .querySelector('.filter-promotion-text')
      .classList.remove('active');
    promotions[i].querySelector('.inactive-promotion-icon').style.display =
      'block';
    promotions[i].querySelector('.active-promotion-icon').style.display =
      'none';
  }

  //Now activate the relevant things
  document
    .querySelector('[data-variant-filter-count="' + variant.option2 + '"]')
    .classList.add('active');
  document
    .querySelector('[data-variant-filter-count="' + variant.option2 + '"]')
    .firstElementChild.classList.add('active');
  const promotion = document.querySelector(
    '[data-variant-promotion-filter-count="' + variant.option2 + '"]'
  );
  promotion.classList.add('active');
  promotion.querySelector('.filter-promotion-text').classList.add('active');
  promotion.querySelector('.inactive-promotion-icon').style.display = 'none';
  promotion.querySelector('.active-promotion-icon').style.display = 'block';

  //* HIDE STUFF FOR OOS *//
  const availableForm = document.getElementById(variant.title + '--oos-form');
  const upsells = document.getElementsByClassName('upsell-container');
  if (availableForm.innerHTML != '') {
    if (!variant.available) {
      const oos_forms = document.getElementsByClassName('oos-form');
      for (let i = 0; i < oos_forms.length; i++) {
        oos_forms[i].style.display = 'none';
      }
      availableForm.style.display = 'block';
      document.getElementById('system-fieldset').style.display = 'none';
      // Hide upsells sections
      const upsellsSections = document.querySelectorAll('.upsells-section');
      for (let i = 0; i < upsellsSections.length; i++) {
        upsellsSections[i].style.display = 'none';
      }
      document.getElementsByClassName(
        'product-add-to-cart-container'
      )[0].style.display = 'none';
    } else {
      const oos_forms = document.getElementsByClassName('oos-form');
      for (let i = 0; i < oos_forms.length; i++) {
        oos_forms[i].style.display = 'none';
      }
      document.getElementById('system-fieldset').style.display = 'block';
      // Show upsells sections
      const upsellsSections = document.querySelectorAll('.upsells-section');
      for (let i = 0; i < upsellsSections.length; i++) {
        upsellsSections[i].style.display = 'block';
      }
      document.getElementsByClassName(
        'product-add-to-cart-container'
      )[0].style.display = 'block';
    }
  } else {
    const oos_forms = document.getElementsByClassName('oos-form');
    for (let i = 0; i < oos_forms.length; i++) {
      oos_forms[i].style.display = 'none';
    }
    document.getElementById('system-fieldset').style.display = 'block';
    // Show upsells sections
    const upsellsSections = document.querySelectorAll('.upsells-section');
    for (let i = 0; i < upsellsSections.length; i++) {
      upsellsSections[i].style.display = 'block';
    }
    document.getElementsByClassName(
      'product-add-to-cart-container'
    )[0].style.display = 'block';
  }

  //Ensure correct text in promotion text, and show or hide promotion based on if there actually is a promotion
  //Check if any visible variants should display a promotion, and update their stuff if so
  for (let i = 0; i < containers.length; i++) {
    let containerOption1 = containers[i].dataset.variantColor;
    let containerOption2 = containers[i].dataset.variantFilterCount;
    let promotionText = document.getElementById(
      containerOption1 + ' / ' + containerOption2 + '--promotion-text'
    ).value;
    if (!promotionText || promotionText == '' || promotionText == null) {
      //Hide Promotion
      document
        .querySelector('[data-variant-filter-count="' + containerOption2 + '"]')
        .classList.remove('promotion');
      document
        .querySelector('[data-variant-filter-count="' + containerOption2 + '"]')
        .firstElementChild.classList.remove('promotion');
      containers[i].querySelector(
        '[data-variant-promotion-filter-count="' + containerOption2 + '"]'
      ).style.display = 'none';
    } else {
      containers[i].querySelector(
        '.filter-promotion-text'
      ).firstElementChild.innerHTML = promotionText;
      //Show Promotion
      document
        .querySelector('[data-variant-filter-count="' + containerOption2 + '"]')
        .classList.add('promotion');
      document
        .querySelector('[data-variant-filter-count="' + containerOption2 + '"]')
        .firstElementChild.classList.add('promotion');
      containers[i].querySelector(
        '[data-variant-promotion-filter-count="' + containerOption2 + '"]'
      ).style.display = 'flex';
    }
  }

  // *END UPDATE BUTTON ACTIVE STATE* //

  // *HANDLE VARIANT LEVEL UPSELLS* //
  const variantUpsellsSections = document.querySelectorAll(
    '.variant-upsells-section'
  );
  const variantUpsells = document.getElementsByClassName(
    'variant-upsell-container'
  );

  // Show/hide variant-specific upsells sections
  variantUpsellsSections.forEach(section => {
    const variantId = section.getAttribute('data-variant-id');
    if (variantId == variant.id) {
      section.style.display = 'block';
    } else {
      section.style.display = 'none';
    }
  });

  let selectedUpsells = [];
  for (let i = 0; i < variantUpsells.length; i++) {
    let upsell = variantUpsells[i];
    let isSelected = upsell.classList.contains('active') ? true : false;
    let upsellVariant = upsell.id.split('-')[0];
    let upsellID = upsell.id.split('-')[1];
    let upsellProductID = document.getElementById(
      upsellVariant + '-' + upsellID + '-productID'
    );

    if (!upsellProductID) continue;

    if (isSelected) {
      selectedUpsells.push(upsellProductID.value);
    }

    // Display is now handled by the parent section, so we don't need to set individual display here

    if (isSelected && upsellVariant != variant.id) {
      // Deselect upsells that don't belong to current variant
      toggleUpsell(upsellVariant + '-' + upsell.id.split('-')[1]);
    }
  }

  // Re-select upsells that belong to current variant
  for (let i = 0; i < variantUpsells.length; i++) {
    let upsell = variantUpsells[i];
    let upsellVariant = upsell.id.split('-')[0];
    let upsellID = upsell.id.split('-')[1];
    let upsellProductID = document.getElementById(
      upsellVariant + '-' + upsellID + '-productID'
    );

    if (!upsellProductID) continue;

    if (
      selectedUpsells.includes(upsellProductID.value) &&
      upsellVariant == variant.id &&
      !upsell.classList.contains('active')
    ) {
      toggleUpsell(upsellVariant + '-' + upsellID);
    }
  }
});
